module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/barnplay-0005eee3a97c31b3b746ba9dfd86d5d2.jpg";